import { generateCaptchaTokenResult as _generateCaptchaTokenResult } from '@worldcoo/ui/lib/captcha';
import { getRuntimeRecaptchaSiteKey } from './shared';

export function generateCaptchaTokenResult() {
	return _generateCaptchaTokenResult(getRuntimeRecaptchaSiteKey());
}
